const validationType = Object.freeze({
    AlphaNumeric16Characters: "alphaNumeric16Characters",
    Numeric: "numeric",
    AlphaNumeric: "alphaNumeric",
    Alphabet : "alphabet",
    Email : "email",

});

export default validationType;